import React from 'react';

export interface IconProps {
  size?: string | number;
  style?: React.CSSProperties;
  color?: string;
  fontSize?: string | number;
  secondaryColor?: string;
}

export const validSocialNames = [
  'adobe',
  'airbnb',
  'amazon',
  'apple',
  'atlassian',
  'binance',
  'booking',
  'bukalapak',
  'chromedp',
  'cloudflare',
  'cypress',
  'deliveroo',
  'disneyplus',
  'duolingo',
  'ebay',
  'facebook',
  'flipkart',
  'freelancer',
  'github',
  'glassdoor',
  'google',
  'google analytics',
  'googleads',
  'google tag manager',
  'gravatar',
  'jquery',
  'hubspot',
  'instagram',
  'lastpass',
  'linkedin',
  'microsoft',
  'mysql',
  'office365',
  'paypal',
  'php',
  'pinterest',
  'playwright',
  'puppeteer',
  'rss',
  'samsung',
  'selenium',
  'skype',
  'snapchat',
  'spotify',
  'telegram',
  'trustpilot',
  'twitter',
  'viber',
  'weibo',
  'wordpress',
  'whatsapp',
  'yahoo',
  'empty',
] as const;

// Step 2: Create a type from the array
export type SocialIconsType = (typeof validSocialNames)[number];

export const validIconNames = [
  'success',
  'warning',
  'error',
  'errorwarning',
  'errorunknown',
  'mic',
  'headphones',
  'videocam',
  'battery20',
  'batterycharging20',
  'battery30',
  'batterycharging30',
  'battery50',
  'batterycharging50',
  'battery60',
  'batterycharging60',
  'battery80',
  'batterycharging80',
  'battery90',
  'batterycharging90',
  'battery100',
  'batterycharging100',
  'empty',
] as const;

// Step 2: Create a type from the array
export type IconsType = (typeof validIconNames)[number];
